module.exports = __webpack_public_path__ + "static/media/roll-dice-20.c514b52e.png";